import React, { useMemo } from 'react';
import { SubScreenLayout } from 'core/models/layout';
import { CameraSettingFormGroup } from 'components/views/molecules/CameraSettingFormGroup';
import styled from '@emotion/styled';
import { fontFamily } from 'components/views/default';
import { MediaDevice, CameraDevice } from 'core/models/mediaDevice';

const Frame = styled.div({
    minWidth: '30em',
});

const SubScreenName = styled.div({
    fontFamily,
    fontSize: 'x-large',
    ':before': {
        fontFamily,
        content: '"Sub Display "',
        fontSize: 'x-large',
    }
});

export type SubScreenLayoutSettingPanelProps = {
    className?: string;
    subscreenNumber: number;
    cameraDevices: CameraDevice[] | undefined;
    layout: SubScreenLayout;
    onUpdate: (layout: SubScreenLayout) => void;
    getVideoConfig?: (mediaDeviceId: MediaDevice.Id) => Promise<Partial<MediaDevice.VideoConfig>>;
    putVideoConfig?: (mediaDeviceId: MediaDevice.Id, config: Partial<MediaDevice.VideoConfig>) => Promise<void>;
}

export function SubScreenLayoutSettingPanel(props: SubScreenLayoutSettingPanelProps) {
    const { subscreenNumber, cameraDevices, onUpdate, layout, getVideoConfig, putVideoConfig } = props;

    function makeDuplicateList(layout: SubScreenLayout) {
        const countByPosition =
            [...layout.center, ...layout.top, ...layout.bottom]
                .reduce((s, c) => s.set(c.tag, (s.get(c.tag) ?? 0) + 1), new Map<MediaDevice.Tag | undefined, number>());
        return new Set([...countByPosition.entries()].reduce((a, [k, n]) => (k && n > 1) ? [...a, k] : a, [] as MediaDevice.Tag[]));
    }
    const duplicateCameras = useMemo(() => makeDuplicateList(layout), [layout]);

    function onCheckedUpdate(layout: SubScreenLayout) {
        onUpdate(layout);
    }

    return (
        <Frame className={props.className}>
            <SubScreenName>{subscreenNumber}</SubScreenName>
            <CameraSettingFormGroup groupName='Center' keyBase='center'
                min={1} max={1}
                assignedCameras={layout.center}
                duplicateCameras={duplicateCameras}
                cameraDevices={cameraDevices}
                onChange={main => onCheckedUpdate({ ...layout, center: main })}
                getVideoConfig={getVideoConfig}
                putVideoConfig={putVideoConfig}
            />
        </Frame>
    );
}
